import type { CollectedShop, CollectedProgram } from "@app/server/client";
import type { MembershipWalletPass } from "@app/server/trpc/routers/wallet-passes";
import type { CoinWalletPass } from "@app/server/trpc/routers/wallet-passes";

/** A coin program with the shop it belongs to, which the card face needs to name. */
export type CoinCardItem = {
  kind: "coin";
  key: string;
  shop: CollectedShop;
  program: CollectedProgram;
  walletPass?: CoinWalletPass;
};
/** A membership pass, which has no balance or tiers of its own. */
export type MembershipCardItem = {
  kind: "membership";
  key: string;
  pass: MembershipWalletPass;
};
/** One card in the wallet — a coin program or a membership. */
export type WalletItem = CoinCardItem | MembershipCardItem;

/**
 * A place is a restaurant (or a group), holding every card that belongs to it.
 * `shop` is present when the place has coin activity — it carries the visits and
 * global `profile_id` the till QR encodes; a membership-only place has none.
 */
export type Place = {
  key: string;
  name: string;
  slug: string | null;
  shop: CollectedShop | null;
  items: WalletItem[];
};

/**
 * Keys are namespaced so a coin program id and a membership program id (uuids
 * from different tables) can never collide in the deck, the open sheet or the
 * front-card tracking. The membership prefix is what the `?membership_program`
 * deep link maps onto.
 */
export const COIN_PREFIX = "coin:";
export const MEM_PREFIX = "mem:";
